import * as z from "zod";

export const serverResponse = z.object({
  email: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  attributes: z.object({
    contactNumber: z.array(z.string()).optional(),
  }),
});
